import { __awaiter, __generator } from "tslib";
import { getComponentId } from '../../../utils';
import { encode } from './WixStyleColors';
import { decodeWixStyles } from './decodeWixStyles';
var WixStyles = /** @class */ (function () {
    function WixStyles(SDKAdapter, editorSDK) {
        var _this = this;
        this.refresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var compRef, styles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.editorSDK) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.editorSDK.components.getById('token', {
                                id: getComponentId(),
                            })];
                    case 1:
                        compRef = _a.sent();
                        return [4 /*yield*/, this.editorSDK.document.tpa.getStyleParams('token', {
                                compRef: compRef,
                            })];
                    case 2:
                        styles = _a.sent();
                        return [2 /*return*/, this.normalizeStylesReceivedFromEditorSDK(styles)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.decode = function (params, siteColors, textPresets) {
            if (!params) {
                return null;
            }
            return decodeWixStyles(params, siteColors, textPresets);
        };
        this.SDKAdapter = SDKAdapter;
        this.editorSDK = editorSDK;
    }
    WixStyles.prototype.setBooleanParam = function (key, value) {
        this.SDKAdapter.setBooleanParam(key, value);
    };
    WixStyles.prototype.setFontParam = function (key, value) {
        this.SDKAdapter.setFontParam(key, value);
    };
    WixStyles.prototype.setNumberParam = function (key, value) {
        this.SDKAdapter.setNumberParam(key, value);
    };
    WixStyles.prototype.setColorParam = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var siteColors, color;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.SDKAdapter.getSiteColors()];
                    case 1:
                        siteColors = _a.sent();
                        color = encode(value, siteColors);
                        this.SDKAdapter.setColorParam(key, color);
                        return [2 /*return*/];
                }
            });
        });
    };
    WixStyles.prototype.load = function () {
        return this.SDKAdapter.getStyleParams();
    };
    WixStyles.prototype.getSiteTextPresets = function () {
        return this.SDKAdapter.getSiteTextPresets();
    };
    WixStyles.prototype.getSiteColors = function () {
        return this.SDKAdapter.getSiteColors();
    };
    WixStyles.prototype.normalizeStylesReceivedFromEditorSDK = function (styles) {
        return __awaiter(this, void 0, void 0, function () {
            var _loop_1, this_1, _a, _b, _i, color;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _loop_1 = function (color) {
                            var siteColors, siteColor;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        if (!(styles.colors.hasOwnProperty(color) &&
                                            styles.colors[color].hasOwnProperty('themeName'))) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_1.getSiteColors()];
                                    case 1:
                                        siteColors = _d.sent();
                                        siteColor = siteColors.find(function (sc) { return sc.name === styles.colors[color].themeName; });
                                        styles.colors[color].themeName = siteColor.reference;
                                        _d.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a = [];
                        for (_b in styles.colors)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        color = _a[_i];
                        return [5 /*yield**/, _loop_1(color)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, styles];
                }
            });
        });
    };
    return WixStyles;
}());
export { WixStyles };
//# sourceMappingURL=WixStyles.js.map